export default "__VITE_ASSET__CmM1dqUS__"